// extracted by mini-css-extract-plugin
module.exports = {"root":"NonDupPatients_root__G3o9h"};